import { render, staticRenderFns } from "./EddyShieldingViz.vue?vue&type=template&id=44fef95a&scoped=true"
import script from "./EddyShieldingViz.vue?vue&type=script&lang=js"
export * from "./EddyShieldingViz.vue?vue&type=script&lang=js"
import style0 from "./EddyShieldingViz.vue?vue&type=style&index=0&id=44fef95a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fef95a",
  null
  
)

export default component.exports